(() => {
  'use strict';

  /* Homepage: show the sticky mobile CTA once the hero CTA scrolls out of view. */
  const initHeroSticky = () => {
    const heroCta = document.querySelector('.avxt-hero__cta');
    const sticky = document.querySelector('.avxt-home-sticky');
    if (!heroCta || !sticky || !('IntersectionObserver' in window) || sticky.dataset.avxtBound) return;
    sticky.dataset.avxtBound = '1';
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }, { threshold: 0 });
    observer.observe(heroCta);
  };

  /* Light / dark switch. The <head> applies a stored "dark" before first paint; the label swaps in CSS; this keeps aria-pressed, the meta and storage in step. */
  const root = document.documentElement;
  const THEME_KEY = 'avxt-theme';
  const isDark = () => root.getAttribute('data-theme') === 'dark';
  const paintTheme = (dark) => {
    root.setAttribute('data-theme', dark ? 'dark' : 'light');
    const themeColor = document.querySelector('[data-avxt-theme-color]');
    if (themeColor) themeColor.setAttribute('content', dark ? '#1b1a18' : '#f4f1eb');
    document.querySelectorAll('[data-avxt-theme-toggle]').forEach((button) => button.setAttribute('aria-pressed', String(dark)));
  };
  const initThemeToggle = () => {
    paintTheme(isDark());
    document.querySelectorAll('[data-avxt-theme-toggle]').forEach((button) => {
      if (button.dataset.avxtBound) return;
      button.dataset.avxtBound = '1';
      button.addEventListener('click', () => {
        const dark = !isDark();
        paintTheme(dark);
        try { localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light'); } catch (e) { /* storage unavailable: the choice lasts for this page only */ }
      });
    });
  };

  /* Cart: sticky mobile Checkout hides when the in-page Checkout button is visible. */
  const initCartSticky = () => {
    const sticky = document.querySelector('[data-avxt-cart-sticky]');
    const inPage = document.querySelector('[data-avxt-cart-checkout]');
    if (!sticky || !inPage || !('IntersectionObserver' in window) || sticky.dataset.avxtBound) return;
    sticky.dataset.avxtBound = '1';
    const observer = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-hidden', entry.isIntersecting);
    }, { threshold: 0.01, rootMargin: '0px' });
    observer.observe(inPage);
  };

  const init = () => { initHeroSticky(); initThemeToggle(); initCartSticky(); };
  init();
  document.addEventListener('shopify:section:load', init);
})();
